module.exports = __webpack_public_path__ + "static/media/icon-destinatario.7d346a90.svg";